import {connect} from "redux-vue";
import * as moduleActions from "../actions/module";
import LoadingIndicator from "./LoadingIndicator";
import classNames from "classnames";

const ModuleItem = {
  props: ['module', 'setModule', 'certificatePDF', 'modelProp'],

  methods: {
    /**
     *
     * @param event
     */
    onPressModule (event) {
      event.preventDefault();
      this.setModule(this.modelProp);
      this.$router.push({name: 'CoursePage', params: {id: this.modelProp.sequence}});
    },

    /**
     *
     */
    onPressDownloadCert () {
      this.certificatePDF(this.modelProp);
    }
  },

  /**
   *
   * @param h
   * @returns {*}
   */
  render (h) {
    const module = this.modelProp;

    const link = (
      <a href={"/courses/" + module.sequence} class="font-bold text-xs lg:text-base text-blue-500 hover:underline" onClick={this.onPressModule}>
        {this.$t('courses_page.course_sequence_name', {
          sequence: module.sequence,
          name: module.name
        })}
      </a>
    );
    
    if (module.completed) {
      return (
        <div class="relative border-b-2">
          <div class="flex flex-col lg:flex-row lg:items-center p-5 lg:py-3 relative">
            <div class="lg:w-1/2">
              <div class="flex items-center">
                <i class="mdi mdi-school text-green-300 mr-2"></i>
                {link}
              </div>
            </div>

            <div class="lg:w-1/2">
              <div
                class="flex flex-col lg:flex-row items-start lg:items-center lg:justify-between pl-3 lg:pl-0">
                <button
                  class="my-3 lg:my-0 px-2 lg:px-5 p-1 lg:p-2 rounded-full border border-blue-600 focus:outline-none text-xs lg:text-base text-blue-600"
                  type="button" onClick={this.onPressDownloadCert} disabled={this.module.createPdf}>
                  {this.module.createPdf && this.module.model.id === module.id
                    ? <LoadingIndicator fill="#3182ce"/>
                    : (
                      <fragment>
                        <i class="mdi mdi-seal mr-2"></i>
                        {this.$t('courses_page.download_cert')}
                      </fragment>
                    )
                  }
                </button>

                <a href={"/courses/" + module.sequence} onClick={this.onPressModule}
                  class="px-2 lg:px-5 p-1 lg:p-2 rounded-full border border-blue-600 focus:outline-none text-xs lg:text-base text-blue-600">
                  {this.$t('courses_page.retake_course')}
                  <i class="mdi mdi-arrow-right ml-3"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      );
    }
    
    const moduleStarted = module.lessons.some(lesson => {
      return lesson.activities.some(activity => activity.started);
    }) || module.percent_complete > 0;

    const btnClass = classNames(
      "px-2 lg:px-5 p-1 lg:p-2 rounded-full focus:outline-none focus:shadow-outline text-xs lg:text-base",
      moduleStarted
        ? "border border-blue-600 text-blue-600"
        : "bg-action hover:bg-action-dark text-white"
    );
    
    const btnText = moduleStarted
      ? this.$t('courses_page.continue_course')
      : this.$t('courses_page.start_course');

    return (
      <li class="relative border-b-2 px-3 lg:px-5 py-5 lg:py-1">
        <div class="flex flex-col lg:flex-row items-center">

          <div class="w-full lg:w-6/12">
            <a href="#" class="font-bold text-blue-500 hover:underline text-xs lg:text-base mr-5 mb-2 lg:mb-0 flex">
              <i class="mdi mdi-progress-check text-black mr-2"></i>
              {link}
            </a>
          </div>
          <div class="w-full lg:w-6/12">
            <div
              class="flex flex-col lg:flex-row items-start lg:items-center lg:justify-between pl-5 lg:pl-0">
              <div class="flex flex-1 w-full lg:w-auto my-5">
                <div class="inline block text-sm lg:text-base mr-2 lg:mr-8">
                  {module.percent_complete}%
                </div>
                <div class="inline-block w-full lg:w-2/5 bg-gray-300 rounded-full overflow-hidden">
                  <div class="h-full bg-green-300 rounded-full" style={`width: ${module.percent_complete}%`}></div>
                </div>
              </div>

              <a href={"/courses/" + module.sequence} class={btnClass} onClick={this.onPressModule}>
                {btnText}
                <i class="mdi mdi-arrow-right ml-3"></i>
              </a>
            </div>
          </div>

        </div>
      </li>
    );
  }
};

function mapStateToProps(state) {
  return {
    module: state.module,
  }
}

function mapActionToProps(dispatch) {
  return {
    setModule: module => dispatch(moduleActions.setModule(module)),
    certificatePDF: module => dispatch(moduleActions.certificatePDF(module)),
  }
}

export default connect(mapStateToProps, mapActionToProps)(ModuleItem);
